module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/.store/axios@0.18.0/~/axios/index.js
// module id = 338
// module chunks = 75